const $ = require('jquery');
const _ = require('lodash');

const openCartMapper = require('../globalheader/atmmapper/open-cart-mapper');

module.exports = function (shopPageStateService, $timeout, $state, settingsService, shopperService,
                           featureService, breakpointsService, globalHeaderPanelService,
                           $rootScope, trolleyService, atm, panelOverride) {
    return {
        restrict: 'E',
        scope: {},
        link(scope, element) {
            const menuPanels = element.find('.globalHeader-smallMenu, globalHeader-overlay'), menu = menuPanels.first();
            scope.shopPageStateService = shopPageStateService;
            scope.globalHeaderPanelService = globalHeaderPanelService;
            scope.panelOverride = panelOverride;
            scope.isMenuOpen = false;
            scope.isShopeLocatorPanelOpened = false;
            scope.shopper = shopperService;
            scope.state = $state;
            scope.isSmallFormat = breakpointsService.isSmallFormat();

            function showHideOutOfScreen() {
                if (scope.isMenuOpen) {
                    menuPanels.removeClass('u-displayNone');
                } else {
                    menuPanels.addClass('u-displayNone');
                }
            }

            scope.togglePanel = function () {
                scope.panelOverride.isOpen = false;
                shopPageStateService.togglePanel('right');
                if (shopPageStateService.panels.right) {
                    globalHeaderPanelService.closePanel();
                    atm.push({}, openCartMapper);
                }
            };

            scope.toggleLocatorPanel = function () {
                scope.isShopeLocatorPanelOpened = !scope.isShopeLocatorPanelOpened;
                scope.globalHeaderPanelService.togglePanel('none');
                shopPageStateService.triggerPanel('right', false);
            };

            scope.closeMenu = function () {
                shopPageStateService.smallFormatMenuOpen = !shopPageStateService.smallFormatMenuOpen;
            };

            scope.$watch(function () {
                    return shopPageStateService.smallFormatMenuOpen;
                },
                function (isMenuOpen) {
                    scope.isMenuOpen = isMenuOpen;
                    if (isMenuOpen) {
                        menuPanels.removeClass('u-displayNone');
                        $('#body-container').addClass('smallFormatMenu-open');
                        menu.focus();
                    } else {
                        $('#body-container').removeClass('smallFormatMenu-open');
                        $timeout(function () {
                            showHideOutOfScreen(isMenuOpen);
                        }, 1000, false);
                    }
                }
            );

            // Get the default panel to display
            settingsService.getSettingValue('OneSite', 'DefaultPageToSpecialGroup')
                .then(function (result) {
                    scope.defaultToSpecialGroup = result && result.toLowerCase() === 'true';
                });

            menu.off('click.smallMenu').on('click.smallMenu', '._navClick', function () {
                scope.closeMenu();
                shopPageStateService.triggerPanel('left', true);
            });


            // auto hide small menu when focus is outside of the panel (eg tab out)
            menu.off('focusout.smallMenu').on('focusout.smallMenu', function () {
                // Timeout here because no item has focus yet, the check will now happen after focusin event has fired.
                $timeout(function () {
                    // toggle if focus goes outside of small menu container
                    if ($(document.activeElement).closest('.globalHeader-smallMenu').length === 0) {
                        shopPageStateService.smallFormatMenuOpen = false;
                    }
                }, 0);
            });

            scope.isGuestAccessToListsEnabled = function () {
                return featureService.isEnabled(featureService.features.enableGuestAccessToLists) && shopperService.currentUser.isGuest;
            };

            scope.toggleSmallFormatMenu = function () {
                const panel = (globalHeaderPanelService.isClosed()) ? globalHeaderPanelService.panels.browse : globalHeaderPanelService.panels.none;
                globalHeaderPanelService.openPanel(panel);

                if (shopPageStateService.panels.right) {
                    shopPageStateService.togglePanel('right');
                }
            };

            scope.trolleyCount = function () {
                return _.sumBy(trolleyService.trolleyProducts, 'Quantity') +
                    _.sumBy(trolleyService.unavailableProducts, 'Quantity') +
                    _.sumBy(trolleyService.partiallyUnavailableProducts, 'Quantity');
            };

            scope.closePanels = function () {
                if (shopPageStateService.panels.right) {
                    shopPageStateService.triggerPanel('right', false);
                }
                if (shopPageStateService.panels.left) {
                    shopPageStateService.triggerPanel('left', false);
                }
            };

            $rootScope.$on('login:success', function () {
                if (shopPageStateService.panels.left) {
                    shopPageStateService.triggerPanel('left', false);
                }
            });

            scope.$on('$stateChangeSuccess', () => {
                scope.closePanels();
            });
        },
        template: require('./small-format-menu-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/smallformatmenu/small-format-menu-directive.js
 **/